import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { CustomFontAwesomeIconProps } from './types/custom-font-awesome-icon.props';

export const BellSlash = (props: CustomFontAwesomeIconProps) => {
  return (
    <FontAwesomeIcon
      icon={['fass', 'bell-slash']}
      {...props}
    />
  );
};
